import { Typography } from '../../../../core/components/molecules/Typography';

type FontSize = 'default' | 'small' | 'large' | 'verySmall';

interface IFontButtons {
  changeFont: (size: FontSize) => void;
  fontSize: string;
  allowSuperSmall?: boolean;
  isBlocked?: boolean;
}

const OPTIONS: { value: FontSize; label: string; letterSize: string; boxSize: string }[] = [
  { value: 'verySmall', label: 'Pequena', letterSize: 'text-[16px]', boxSize: 'h-[52px] w-[52px]' },
  { value: 'small', label: 'Média', letterSize: 'text-[24px]', boxSize: 'h-[60px] w-[60px]' },
  { value: 'default', label: 'Grande', letterSize: 'text-[28px]', boxSize: 'h-[64px] w-[64px]' },
  { value: 'large', label: 'Extra grande', letterSize: 'text-[34px]', boxSize: 'h-[68px] w-[68px]' },
];

export default function FontButtons({ changeFont, fontSize, allowSuperSmall = false, isBlocked = false }: IFontButtons) {
  const options = allowSuperSmall ? OPTIONS : OPTIONS.filter(option => option.value !== 'verySmall');

  return (
    <div className='flex flex-col items-start gap-[15px] lg:flex-row lg:items-center lg:justify-between lg:gap-xxl mb-4'>
      <div className='flex flex-col gap-xs'>
        <Typography weight='bold' className='text-[16px]'>Escolha o tamanho da fonte</Typography>
        <Typography className='text-[14px] text-[#6B7694]'>Selecione o tamanho da fonte para a sua redação.</Typography>
      </div>
      <div className='flex flex-row items-end justify-between gap-l'>
        {options.map(({ value, label, letterSize, boxSize }) => {
          const selected = fontSize === value;
          return (
            <button
              key={value}
              type='button'
              onClick={() => !isBlocked && changeFont(value)}
              style={{ border: 'none', outline: 'none', background: 'transparent', padding: 0 }}
              className={`flex w-[88px] flex-col items-center justify-end gap-xs ${isBlocked ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            >
              <span
                style={{
                  border: selected ? '2px solid #2E3FD6' : '1px solid #D5DBE8',
                  backgroundColor: selected ? '#E3EAFF' : '#FFFFFF',
                  color: '#0B1B4D',
                }}
                className={`flex items-center justify-center rounded-[12px] ${boxSize}`}
              >
                <span className={`font-medium leading-none ${letterSize}`}>T</span>
              </span>
              <span
                style={{ color: selected ? '#2E3FD6' : '#6B7694' }}
                className={`whitespace-nowrap text-[14px] ${selected ? 'font-medium' : ''}`}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
